/** Saves text the page generated (reports) as a file in the browser. */
export function downloadText(fileName: string, content: string, type: string): void {
  const url = URL.createObjectURL(new Blob([content], { type }))
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.append(link)
  link.click()
  link.remove()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}

/** Starts a download served by the app itself (backups), keeping the session cookie. */
export function downloadFromServer(path: string): void {
  const link = document.createElement('a')
  link.href = path
  link.download = ''
  document.body.append(link)
  link.click()
  link.remove()
}
